import React,{useState} from 'react';
import { Skeleton, Row, Col, Carousel , Spin,List,Avatar,Drawer,Button} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BicycleParkingSpotMoreInfo } from './BicycleParkingSpotMoreInfo';
import './BicycleParkingSpotInfo.css';

import { bicycleParkingService } from '../../services';
import { ConsoleView } from 'react-device-detect';
import { config } from '../../config';

export const BicycleParkingSpotCard = ({bicycleParkingSpotType,bicycleParkingPhoto,bicycleParkingSpotID,setShowBicycleParkingVisible,onEditLocation, ...otherProps}) => {
    let [moreInfoVisible,setMoreInfoVisible]=useState(false)
    let [bicycleParkingSpot,setBicycleParkingSpot]=useState(false)
   
    async function getSpotInfo(id) {
        const bicycleParking = await bicycleParkingService.getBicycleParking(id);
        setBicycleParkingSpot(bicycleParking)
    }
    const toggleShowMoreInfo = (e) =>{
		setMoreInfoVisible(!moreInfoVisible);      
        getSpotInfo(bicycleParkingSpotID);        
	}
    return (
        
        <>
           <Button className='bicycleParkingSpotCard' onClick={(e)=>toggleShowMoreInfo(bicycleParkingSpotID)} >
            <img className='bicycleParkingSpotImage' src={`${config.url}${bicycleParkingPhoto}` }></img>
            <p className='bicycleParkingSpotType'>{bicycleParkingSpotType}</p>
           </Button>
            


           <Drawer
                title={"Detaljne informacije"}
                width="600px"
                destroyOnClose={true}
				className={`bicycleParkingSpot-card`}
				placement="right"	
                closable={true}
				mask={true}
				onClose={toggleShowMoreInfo}
                onCancel={toggleShowMoreInfo}
                visible={moreInfoVisible}
				footer={null}
            >
				
				<BicycleParkingSpotMoreInfo 
                bicycleParkingSpot={bicycleParkingSpot}      
                onDataUpdate={otherProps.onDataUpdate}
                setShowBicycleParkingVisible={setShowBicycleParkingVisible}
                onEditLocation={onEditLocation}
            >
            </BicycleParkingSpotMoreInfo>

			</Drawer>

            
        </>
    )
    }